/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import * as Radix from '@radix-ui/themes/helpers';


export const SCALES =
[
  'gray', 'ruby', 'red', 'crimson', 'plum', 'purple', 'cyan', 'blue', 'teal',
  'jade', 'indigo', 'bronze', 'green', 'grass', 'lime', 'yellow', 'orange', 'tomato', 'amber',
];


export const colorAt = (index) =>
{
  return SCALES[index];
};


export const colorIndexOf = (color) =>
{
  return SCALES.indexOf(color);
};


export const getMatchingGrayColor = (color) =>
{
  return color !== null ? Radix.getMatchingGrayColor(color) : null;
};


// Excludes 'gray' at index 0 — random account colors are never gray.
export const randomColorIndex = () =>
{
  return 1 + Math.floor(Math.random() * (SCALES.length - 1));
};
